module.exports = __webpack_public_path__ + "static/media/desktop.fa91e6ee.svg";